import { Heading } from '@msdyn365-commerce-modules/utilities';
import { RichTextComponent } from '@msdyn365-commerce/core';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { BusLoader, LoadBus } from '../../Utilities/event-bus';
import { createGetMembershipInput, getMembershipAction, IGetMembershipData } from './actions/get-membership.action';
import { WineClubMembership } from './components/wine-club-membership';
import { IWineClubManagementData } from './wine-club-management.data';
import { IWineClubManagementProps } from './wine-club-management.props.autogenerated';

/**
 *
 * WineClubManagement component
 * @extends {React.Component<IWineClubManagementProps<IWineClubManagementData>>}
 */
@LoadBus('wine-club-management')
@observer
class WineClubManagement extends React.Component<IWineClubManagementProps<IWineClubManagementData>> {

    private bus: BusLoader | undefined;

    @observable private memberData: IGetMembershipData | null = null;
    @observable private isEditingClub: boolean = false;

    constructor(props: IWineClubManagementProps<IWineClubManagementData>) {
        super(props);
        this.bus!.subscribe<string>('success', async () => {
            this.memberData = await getMembershipAction(
                createGetMembershipInput(this.props.context.actionContext),
                this.props.context.actionContext
            );
        });
    }

    public render(): JSX.Element | null {
        const membershipInfo = this.memberData || this.props.data.wineClubMember.result;
        if (!membershipInfo) { return null; }

        const { title } = this.props.config;

        const accountHasMemberships = membershipInfo.Status !== 'NOTFOUND_WINECLUBMEMBERSHIP' && membershipInfo.Result && membershipInfo.Result.length ? true : false;
        return (
            <div className='wine-club-management'>
                {title && <Heading {...title} className='wine-club-management__heading' />}
                {accountHasMemberships &&
                    <div className='wine-club-management__content'>
                        <div className='wine-club-management__table'>
                            {this._tableHeadJSX}
                            {this._membershipsDisplayJSX(membershipInfo)}
                        </div>
                        {this._footnoteJSX}
                    </div>
                }
                {!accountHasMemberships && this._noMembershipJSX}
            </div>
        );
    }

    private get _noMembershipJSX(): JSX.Element | null {
        const { slots } = this.props;
        const hasSlots = slots && slots.contentBlock && slots.contentBlock.length;
        if (hasSlots) {
            return (
                <React.Fragment>
                    {this._renderSlotItems(slots.contentBlock)}
                </React.Fragment>
            );
        }
        return null;
    }

    private _renderSlotItems(items: React.ReactNode[]): JSX.Element {
        return (
            <React.Fragment>
                {items.map((slot: React.ReactNode, index: number) => (
                    <React.Fragment key={index}>
                        {slot}
                    </React.Fragment>
                ))}
            </React.Fragment>
        );
    }

    private get _tableHeadJSX(): JSX.Element {
        const {
            wineClubManagement__tableStatus,
            wineClubManagement__tableClub,
            wineClubManagement__tableActions,
            wineClubManagement__tableActivationStartDate,
            wineClubManagement__tableActivationNextShipDate
        } = this.props.resources;
        return (
            <div className='wine-club-management__table-head'>
                {
                    <div className='wine-club-management__table-cell wine-club-management__table-cell__status'>
                        {wineClubManagement__tableStatus}
                    </div>
                }
                <div className='wine-club-management__table-cell wine-club-management__table-cell__club'>
                    {wineClubManagement__tableClub}
                </div>
                <div className='wine-club-management__table-cell wine-club-management__table-cell__date wine-club-management__table-cell__date-start'>
                    {wineClubManagement__tableActivationStartDate}
                </div>
                <div className='wine-club-management__table-cell wine-club-management__table-cell__date wine-club-management__table-cell__date-next'>
                    {wineClubManagement__tableActivationNextShipDate}
                </div>
                <div className='wine-club-management__table-cell wine-club-management__table-cell__actions'>
                    {wineClubManagement__tableActions}
                </div>
            </div>
        );
    }

    private get _footnoteJSX(): JSX.Element | null {
        const { note } = this.props.config;
        if (!note) { return null; }
        return (
            <div className='wine-club-management__note'>
                <RichTextComponent text={note} />
            </div>
        );
    }

    private _membershipsDisplayJSX(membershipInfo: IGetMembershipData): JSX.Element[] | undefined {
        return membershipInfo.Result?.map((clubMembership, key) => {
            return (
                <WineClubMembership
                    context={this.props.context}
                    membership={clubMembership}
                    managementProps={this.props}
                    key={key}
                    updateEditingClub={(state) => {
                        this.isEditingClub = state;
                    }}
                    isEditingClub={this.isEditingClub}
                />
            );
        });
    }
}

export default WineClubManagement;